function handleProductUrlInput(input) {
    let updatedInput = input;
    updatedInput = updatedInput.replace(" ", "-");
    updatedInput = updatedInput.replace("/", "-");
    updatedInput = updatedInput.replace("--", "-");
    updatedInput = updatedInput.toLowerCase();
    return updatedInput;
}

export default handleProductUrlInput;
